import React, { FC } from 'react';
import {
  Box,
  makeStyles,
  createStyles,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  paper: {
    color: 'white',
    height: '1122px',
    width: '793px',
  },
  header: {
    height: '50px',
    backgroundColor: '#0F4B8D',
    textAlign: 'right',
  },
  headerTitle: {
    marginLeft: '15px',
    lineHeight: '50px',
  },
  headerImage: {
    height: '35px',
    marginTop: '5px',
    marginRight: '15px',
  },
  footer: {
    height: '50px',
    backgroundColor: '#0F4B8D',
  },
  pageNumber: {
    lineHeight: '50px',
    textAlign: 'right',
    paddingRight: '30px',
  },
  contents: {
    height: '1022px',
  },
}));

interface PrintedPageProps {
  pageNumber?: number;
  pageTitle?: string;
}

const PrintedPage: FC<PrintedPageProps> = (props) => {
  const classes = useStyles();
  const logoSrc = 'https://res.cloudinary.com/dxaubvelx/image/upload/v1576036742/webassets/images/inrutawhite_qwpumj.png';
  return (
    <Box className={classes.paper}>
      <Box className={classes.header} display="flex">
        <Typography className={classes.headerTitle}>
          {props?.pageTitle}
        </Typography>
        <Box flexGrow={1} />
        <img
          className={classes.headerImage}
          src={logoSrc}
          alt="logo"
        />
      </Box>
      <Box className={classes.contents}>{props?.children}</Box>
      <Box className={classes.footer}>
        {props?.pageNumber ? (
          <Typography className={classes.pageNumber}>
            {props?.pageNumber}
          </Typography>
        ) : (
          undefined
        )}
      </Box>
    </Box>
  );
};

export default PrintedPage;
